<template>
  <div class="col-12 d-flex flex-column mb-3">
    <div style="flex: 1;margin-left: 45px;">
      <div class="row">
        <div class="col-12">
          <section-title :title="$t('apps.inventory.label.lotnumber')" />
        </div>
      </div>
    </div>
    <div class="form-row">
      <div
        ref="lot-wrapper"
        :class="[{'col-md-9': !disabled, 'col-md-8': disabled}, lotClassName]"
        class="lot-wrapper mb-2"
      >
        <div class="d-flex">
          <div style="width: 45px;"/>
          <div
            class="form-row"
            style="flex: 1;">
            <div class="col-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ $t('apps.inventory.message.bin') }}</span>
                </div>
                <BaseDropdown
                  v-model="value.binId"
                  :options="binOptions"
                  :disabled="disabled" />
              </div>
            </div>
            <div class="col-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ $t('apps.inventory.message.dateproduct') }}</span>
                </div>
                <BaseInputDatePicker
                  v-model="value.dateProduct"
                  :disabled="disabled" />
              </div>
            </div>
            <div class="col-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ $t('apps.inventory.message.dateexpire') }}</span>
                </div>
                <BaseInputDatePicker
                  v-model="value.dateExpire"
                  :disabled="disabled" />
              </div>
            </div>
            <div class="col-3">
              <div class="input-group">
                <div class="input-group-prepend">
                  <span class="input-group-text">{{ $t('apps.inventory.message.cost') }}</span>
                </div>
                <BaseInputNumber
                  v-model="value.cost"
                  :disabled="disabled" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    warehouses: Array,
    selectedWhId: String,
    disabled: Boolean,
  },

  data() {
    return {
      lotClassName: '',
    }
  },

  computed: {
    defaultOption () {
      return {
        text: this.$t('placeholder.select'),
        value: null,
      }
    },
    binOptions () {
      const items = this.warehouses.reduce((acc, cur) => {
        if (cur.warehouse_id === this.selectedWhId) {
          const bins = cur.bin_locations.map((bin) => {
            return {
              text: bin.code,
              value: bin._id,
            }
          })
          if (bins.length) {
            acc.push(...bins)
          }
        }
        return acc
      }, [])
      return [this.defaultOption, ...items]
    },
  },

  mounted() {
    this.setLotUI()

    window.addEventListener('resize', this.handleWindowResize)
  },

  destroyed() {
    window.removeEventListener('resize', this.handleWindowResize, false)
  },

  methods: {
    setLotUI() {
      const lotWrapper = this.$refs['lot-wrapper']
      if (lotWrapper.clientWidth < 800) {
        this.lotClassName = 'responsive'
      } else {
        this.lotClassName = ''
      }
    },
    handleWindowResize() {
      this.setLotUI()
    },
  },
}
</script>

<style scoped>
.lot-wrapper {
  height: 38px;
}

.lot-wrapper.responsive {
  height: auto;
}

.lot-wrapper.responsive .form-row > div {
  width: 100%;
  max-width: 100%;
  flex: none;
  margin-bottom: .5rem;
}

.lot-wrapper.responsive .form-row > div:last-of-type {
  margin-bottom: 0;
}

.lot-wrapper.responsive .form-row .input-group-text {
  min-width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseGRPutAwayLot.vue